import { getAPI , postAPI , EmbeddedPostAPI, putAPI} from "../../../../api/apis"
import { REACT_APP_CANDIDATE , REACT_APP_CONTRACTSIGN, REACT_APP_TIMESHEET , REACT_APP_TIMESHEET_PAYMENT } from "../../../../utils/common"

export async function getTimeSheetHistory(candidateId: string | null, candidateJobId: string){
    const Details = getAPI( REACT_APP_TIMESHEET + `/candidate-timesheet/${candidateId}?draft=false&candidateJobId=${candidateJobId}`)
    return Details
}

export async function getPendingTimesheets(candidateId: string | null, candidateJobId: string){
    const Details = getAPI( REACT_APP_TIMESHEET + `/candidate-timesheet/${candidateId}?draft=true&candidateJobId=${candidateJobId}`)
    return Details
}

export async function getDetails(Id: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE + `/candidates/${Id}`)
    return Details
}

export async function timesheetDetails(timesheetId: string, projectId: string){
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-details/${timesheetId}?projectId=${projectId}`)
    return Details
}

export async function updateTimeSheet(body: any){  
    const Details = putAPI( REACT_APP_TIMESHEET + '/candidate-timesheet', body)
    return Details
}

export async function resendTimesheet(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEET + '/timesheet-resend', body)
    return Details
}

export async function getHistory(timesheetId: string) {
    const Details = getAPI( REACT_APP_TIMESHEET + `/timesheet-status-history/${timesheetId}`)
    return Details
}

export async function extractTimesheetDownload(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEET + '/timesheet-extract', body)
    return Details  
}

export async function getTimesheetDetails(timesheetId: string) {
    const Details = getAPI( REACT_APP_TIMESHEET_PAYMENT + `/timesheet-invoice-details/${timesheetId}`)
    return Details
}

export async function saveTimeSheetInvoiceDetail(timesheetId?: string, data?: any) {
    const Details = putAPI( REACT_APP_TIMESHEET_PAYMENT + `/timesheet-invoice-details/${timesheetId}`, data)
    return Details
}

export async function getSignatureUrlApi(candidateJobId: any) {
    const Details = getAPI( REACT_APP_CONTRACTSIGN + `/contract-document-details/${candidateJobId}`)
    return Details
}

export async function DropboxApi(body: any) {
    const Details = EmbeddedPostAPI('https://api.hellosign.com/v3/signature_request/create_embedded', body)
    return Details 
}